<div class="media-editor-modal">
  <!-- ================= HEADER ================= -->
  <div class="modal-header mobile-header flex-column align-items-stretch">
    <!-- Linha 1: título + close -->
    <div class="d-flex align-items-center justify-content-between w-100">
      <h4 class="modal-title mb-0">{{ title }}</h4>

      <div class="header-actions">
        <button type="button" class="btn btn-icon btn-close-icon" (click)="dismiss()" aria-label="Fechar"
          title="Fechar">
          <i data-feather="x" [size]="24"></i>
        </button>
      </div>
    </div>

    <!-- Linha 2: descrição -->
    <p *ngIf="description" class="text-muted mb-0 text-primary">
      {{ description }}
    </p>
  </div>

  <!-- ================= BODY ================= -->
  <div class="modal-body-wrapper">
    <div class="modal-body full-page-cropper">
      <!-- IMAGE OR PDF -->
      <ng-container *ngIf="!isPdf; else pdfTemplate">
        <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
      </ng-container>

      <ng-template #pdfTemplate>
        <ng-container *ngTemplateOutlet="pdfTemplateContent"></ng-container>
      </ng-template>
    </div>
  </div>

  <!-- ================= FOOTER ================= -->
  <div class="modal-footer actions-footer">
      <!-- Upload button -->
      <div class="upload-section" *ngIf="showUploadButton">
        <button class="btn btn-upload" (click)="fileUpload.click()">
          <i data-feather="upload" [size]="20"></i>
          <span class="btn-text">{{ uploadButtonText }}</span>
        </button>
      </div>

      <!-- Action buttons -->
      <div class="transform-buttons" [ngClass]="{ 'disabled-center': !imageChangedEvent && !filePreviewUrl }">
        <!-- IMAGE ACTIONS -->
        <ng-container *ngIf="!isPdf">
          <div class="actions">
            <!-- Linha superior -->
            <div class="actions-row">
              <button type="button" class="btn btn-transform" [disabled]="!imageChangedEvent" (click)="rotateLeft()">
                <i data-feather="rotate-ccw" [size]="18"></i>
              </button>

              <button type="button" class="btn btn-transform" [disabled]="!imageChangedEvent" (click)="rotateRight()">
                <i data-feather="rotate-cw" [size]="18"></i>
              </button>

              <button *ngIf="showFlipButtons" type="button" class="btn btn-transform" [disabled]="!imageChangedEvent"
                (click)="flipHorizontal()">
                <i data-feather="flip-horizontal" [size]="18"></i>
              </button>

              <button *ngIf="showFlipButtons" type="button" class="btn btn-transform" [disabled]="!imageChangedEvent"
                (click)="flipVertical()">
                <i data-feather="flip-vertical" [size]="18"></i>
              </button>

              <button type="button" class="btn btn-transform" [disabled]="!imageChangedEvent" (click)="zoomIn()">
                <i data-feather="zoom-in" [size]="18"></i>
              </button>

              <button type="button" class="btn btn-transform" [disabled]="!imageChangedEvent" (click)="zoomOut()">
                <i data-feather="zoom-out" [size]="18"></i>
              </button>
            </div>

            <!-- Linha inferior -->
            <div class="actions-row actions-row-bottom" *ngIf="imageChangedEvent">
              <button type="button" class="btn btn-transform btn-change" (click)="selectNewFile()">
                <i data-feather="refresh-cw" [size]="18"></i>
              </button>

              <button type="button" class="btn btn-transform btn-remove" (click)="remove()">
                <i data-feather="trash-2" [size]="18"></i>
              </button>

              <button type="button" class="btn btn-transform btn-save" (click)="confirm()">
                <i data-feather="check" [size]="18"></i>
              </button>
            </div>
          </div>
        </ng-container>

        <!-- PDF ACTIONS -->
        <ng-container *ngIf="isPdf">
          <button *ngIf="filePreviewUrl" type="button" class="btn btn-transform btn-change" (click)="selectNewFile()"
            title="Trocar arquivo">
            <i data-feather="refresh-cw" [size]="18"></i>
          </button>

          <button *ngIf="filePreviewUrl" type="button" class="btn btn-transform btn-remove" (click)="remove()"
            title="Remover PDF">
            <i data-feather="trash-2" [size]="18"></i>
          </button>

          <button *ngIf="filePreviewUrl" type="button" class="btn btn-transform btn-save" (click)="confirm()"
            [title]="saveButtonText">
            <i data-feather="check" [size]="18"></i>
          </button>
        </ng-container>
      </div>
    </div>
</div>

<!-- ================= TEMPLATES ================= -->

<ng-template #imageTemplate>
  <div class="image-container" *ngIf="!imageChangedEvent && !showUploadButton" (click)="fileUpload.click()">
    <div class="empty-image-placeholder-with-upload">
      <i data-feather="image" [size]="56"></i>
      <span>{{ uploadContentText }}</span>
      <span class="description-upload-content-text">{{ descriptionuploadContentText }}</span>
    </div>
  </div>

  <div class="image-container" *ngIf="!imageChangedEvent && showUploadButton">
    <div class="empty-image-placeholder">
      <i data-feather="image" [size]="56"></i>
    </div>
  </div>

  <div class="image-container" *ngIf="imageChangedEvent">
    <image-cropper #cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="maintainAspectRatio"
      [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="aspectRatio" [autoCrop]="autoCrop"
      [output]="outputFormat" [format]="imageFormat" [resizeToWidth]="resizeToWidth"
      [resizeToHeight]="resizeToHeight" [transform]="transform" [allowMoveImage]="allowMoveImage"
      (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()">
    </image-cropper>
  </div>
</ng-template>

<ng-template #pdfTemplateContent>
  <div class="pdf-viewer-container" *ngIf="filePreviewUrl">
    <object [data]="filePreviewUrl" type="application/pdf" class="pdf-viewer"></object>
  </div>
</ng-template>

<!-- ================= FILE INPUT ================= -->
<input #fileUpload type="file" hidden [accept]="acceptFileTypes" (change)="onFileChanged($event)" />